import { Injectable } from '@angular/core';

import { RouteTag } from '@frontend/sports/common/core/data-access/route';
import { RouterEventsService } from '@frontend/sports/common/core/utils/router-events';
import { Observable, map } from 'rxjs';

@Injectable()
export class MultiReturnsMessageNavigationService {
    isRouteMessageTimeoutEnabled$: Observable<boolean>;

    constructor(private routerEventsService: RouterEventsService) {
        this.isRouteMessageTimeoutEnabled$ = this.routerEventsService.currentActivationEnd.pipe(
            map((event) => event?.snapshot?.data['tag'] !== RouteTag.MultiBuilder),
        );
    }
}
